import React from "react";
import { Link } from "react-router-dom";
import "../css/navbar.css";

function NavStrip({ isTrialOrg }) {
  return (
    <div className="nav-strip">

    <a
      href="https://calendar.app.google/wKTSFtJx4VFNMVJh7"
      className="nav-item"
    >
      <span>✨</span>
      <span>Book your free Onboarding & Setup Session now →</span>
    </a>
  
    <a
      href="https://www.youtube.com/@booleanug2658/videos"
      target="_blank"
      rel="noopener noreferrer"
      className="nav-item"
    >
      <span>🎥</span>
      <span>Short Demo Videos  → </span>
      <span>https://www.youtube.com/@booleanug2658/videos</span>
    </a>
  
    <Link to="/contactForm" className="nav-item">
      <span>💬</span>
      <span>For Issues, Feedback & Requests — Message us</span>
    </Link>
  
  </div>
  );
}

export default NavStrip;